import './CreateAOSecond.scss';

import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { Button, Checkbox, FormControlLabel, FormGroup, InputAdornment, ThemeProvider } from '@mui/material';
//import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import CategoriesSubCategoriesDropDown from '../../../Components/CategoriesSubCategoriesDropDown';
import { buttonStyles, buttonStylesGreen } from '../../../Components/docsAdministrative/JsObjectStyles';
import QuillAdvancedTextArea from '../../../Components/shared/QuillAdvancedTextArea';
import RegimeModeTravail from '../../../Components/shared/RegimeModeTravail';
import { DatePickerComponent, IconTextField, SelectComponent, TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import SearchCity from '../../../Components/shared/SearchCity';
import SearchUser from '../../../Components/shared/SearchUser';
import { dureeBdcEnum } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useCraRdv from '../../../hooks/useCraRdv';
import useDateRangeValidator from '../../../hooks/useDateRangeValidator';
import useFormValidation, { champRequisString } from '../../../hooks/useFormValidation';
import usePostRequest from '../../../hooks/usePostRequest';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
import { FieldComponentFont } from '../../../Styles/componentStyles';
import { calculateWorkingDaysBetweenDates, isHttpStatusSuccess, isValidDate } from '../../../Utils/utils';
import CreateAOButtonsHeader from './CreateAOButtonsHeader';

const initializeMembre = (index, selectedAO, clientType) => {
    if (index === 0) {
        return {
            ...(clientType === 'esn' ?
                { collaboratorEsnId: selectedAO?.entrepriseData?.responsableOperationnelEsnId } :
                { collaboratorId: selectedAO?.entrepriseData?.responsableOperationnelId }),
            role: null,
            receptionCandidatures: true,
            suiviMission: true,
            index: index,
        };
    } else {
        return {
            ...(clientType === 'esn' ?
                { collaboratorEsnId: null } :
                { collaboratorId: null }),
            role: null,
            receptionCandidatures: true,
            suiviMission: true,
            index: index,
        };
    }
};

const initializeMembreModifCase = (index, member,role) => {
    return {
        ...(role === 'esn' ?
            { collaboratorEsnId: member?.collaboratorEsnId?._id } :
            { collaboratorId: member?.collaboratorId?._id }),
        role: member?.role,
        receptionCandidatures: member?.receptionCandidatures,//Math.random() < 0.5,
        suiviMission: member?.suiviMission, //* was randomly generated Math.random() < 0.5,
        index: index,
    };
};

// ALL scenarios :
// 1- the user is following the natural flow of create AO => selectedAO = null
// 2- the user selects the ao from draft table, to continue the creation process => selectedAO = {ao + isDraft = true}
// ( it's working now without this logic , but I think we will remove theGetAOById and replace it with the the ao that we keep updated with backend all the time)
// 3- user select the AO from the table, to be updated => selectedAO = {ao + isUpdating = true}
function CreateAOSecond() {
    let navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();
    const { postData } = usePostRequest();
    const { setShowErrors, setErrors,errors, setBackdropOpen } = useUtilities();
    const location = useLocation();
    const { selectedAO, setSelectedAO } = useCraRdv();
    const role = useRole();
    const [_id, setAoId] = useState('');
    console.log('selectedAO',selectedAO);
    // ? details publication
    const [intitulePoste, setIntitulePoste] = useState('');
    const [referenceInterne, setReferenceInterne] = useState('');
    const [dateDebutAO, setDateDebutAO] = useState(null);
    const [dateFinAO, setDateFinAO] = useState(null);
    // ? details generales
    const [nbRecrutes, setNbRecrutes] = useState(''); //! was 1 for create mission purpose, but It cause some pbs in required: it is required initially even it has initial values
    // TODO add localisation [ville + pays] from Our API
    const [localisation, setLocalisation] = useState();
    const [modeTravail, setModeTravail] = React.useState({
        type: '',
        nbJrsRemotePerWeek: '',
    });
    const [regimeTravail, setRegimeTravail] = React.useState({
        type: '',
        nbJrsPartielPerWeek: '',
    });
    const [minimumAnneeExp, setMinimumAnneeExp] = useState('');
    const [categorie, setCategorie] = useState('');
    const [sousCategorie, setSousCategorie] = useState('');
    // ? duration et budget
    const [dateDebutMission, setDateDebutMission] = useState(null);
    const [dateFinMission, setDateFinMission] = useState(null);
    const [dureeMission, setDureeMission] = useState(0);
    const [dureeBDC, setDureeBDC] = useState('');
    const [tjMax, setTjMax] = useState('');
    const [visibilityTjMax, setVisibilityTjMax] = useState(false);
    // ? description du poste
    const [description, setDescription] = useState('');
    //? equipe RH
    const [membres, setMembres] = useState([initializeMembre(0, selectedAO,location?.pathname?.includes('esn')?'esn':'client')]); // { nom: null,role: null, reception: null, suivi: null, index: 0, }
    console.log('membres',membres);
    // ? the end
    // juste pour faciliter l'ajout des membres
    // const [newMembres, setNewMembres] = useState([{ nom: null, },]);
    // * required field declaration
    const [isValid] = useFormValidation([
        { name: 'intitulePoste', value: intitulePoste },
        { name: 'dateDebutAO', value: dateDebutAO },
        { name: 'dateFinAO', value: dateFinAO },
        { name: 'nbRecrutes', value: nbRecrutes },
        { name: 'localisation', value: localisation },
        { name: 'dateDebutMission', value: dateDebutMission },
        { name: 'dateFinMission', value: dateFinMission },
        { name: 'minAnnExp', value: minimumAnneeExp },
        { name: 'description', value: description },
        { name: 'sousCategorie', value: sousCategorie },
    ]);
    // * inputs and date's range validation
    const [isValidRangeDateAO, messageRangeDateAO] = useDateRangeValidator(dateDebutAO, dateFinAO);
    const [isValidRangeDateMission, messageRangeDateMission] = useDateRangeValidator(dateDebutMission, dateFinMission);
    const { device } = useWindowSize();
    const { i18n } = useTranslation();
    // calculate duree mission
    useEffect(() => {
        setDureeMission(calculateWorkingDaysBetweenDates(dateDebutMission, dateFinMission, regimeTravail.nbJrsPartielPerWeek));
    }, [dateDebutMission, dateFinMission, regimeTravail.nbJrsPartielPerWeek]);

    useEffect(() => {
        if (location?.state?.aoId) {
            getAoDataById();
        }
    }, [location?.state?.aoId]);

    useEffect(() => {
        if (selectedAO) {
            setBackdropOpen(true);
            setAoId(selectedAO?._id);
            initializeAOSecond(selectedAO);
            if (selectedAO?._id && selectedAO?._id != '') {
                setBackdropOpen(false);
            }
        }
    }, [selectedAO]);

    const initializeAOSecond = (ao) => {
        // setBackdropOpen(true);
        // ? details publication
        setIntitulePoste(ao?.intitulePoste);
        setReferenceInterne(ao?.referenceInterne);
        isValidDate(ao?.dateDebutAO) && setDateDebutAO(ao?.dateDebutAO);
        isValidDate(ao?.dateFinAO) && setDateFinAO(ao?.dateFinAO);
        // ? details generales
        setNbRecrutes(ao?.nbRecrutes);
        setLocalisation(ao?.localisation);
        if (ao?.modeTravail?.type)
            setModeTravail(ao?.modeTravail);
        if (ao?.regimeTravail?.type)
            setRegimeTravail(ao?.regimeTravail);
        setMinimumAnneeExp(ao?.minimumAnneeExp);
        setCategorie(ao?.categorie?.value);
        setSousCategorie(ao?.categorie?.sousCategorie);
        // ? duration et budget
        isValidDate(ao?.dateDebutMission) && setDateDebutMission(ao?.dateDebutMission);
        isValidDate(ao?.dateFinMission) && setDateFinMission(ao?.dateFinMission);
        setDureeMission(ao?.dureeMission);
        setDureeBDC(ao?.dureeBDC);
        setTjMax(ao?.tjMax);
        setVisibilityTjMax(ao?.visibilityTjMax);
        // ? description du poste
        setDescription(ao?.description);
        //? equipe RH
        if (Array.isArray(ao?.membres)) {
            if (ao?.membres.length > 0) {
                if (location?.state?.aoId)
                    // * cas de modification
                    setMembres(ao?.membres?.map((element, index) => initializeMembreModifCase(index, element,location?.pathname?.includes('esn') ? 'esn':'client')));
                else
                    // * cas de creation
                    setMembres(ao?.membres);
            }
        }
        // setBackdropOpen(false);
    };

    const handleKeyDown = (event) => {
        if (event.key === '-') {
            event.preventDefault();
        }
    };
    const getAoDataById = async () => {
        setBackdropOpen(true);
        try {
            const response = await axiosPrivate.get('/ao/getMyAoById/' + location?.state?.aoId);
            setBackdropOpen(false);
            console.log(response?.data?.myAO);
            initializeAOSecond(response?.data?.myAO);
        } catch (error) {
            setBackdropOpen(false);
            console.log(error);
        }
        setBackdropOpen(false);
    };

    const createAO_step2 = async ({ action }) => {
        console.log('membres lors du creation de l\'AO');
        const payloadStep2 = {
            action,
            // ? details publication
            intitulePoste,
            referenceInterne,
            dateDebutAO,
            dateFinAO,
            // ? details generales
            nbRecrutes,
            localisation,
            modeTravail,
            regimeTravail,
            minimumAnneeExp,
            categorie: {
                value: categorie ?? '',
                sousCategorie: sousCategorie ?? '',
            },
            // ? duration et budget
            dateDebutMission,
            dateFinMission,
            dureeMission,
            dureeBDC,
            tjMax,
            visibilityTjMax,
            // ? description du poste
            description,
            //? equipe RH
            membres,
            // * ADMIN CREATE
            companyDataId: selectedAO?.companyDataId
        };
        let response1;
        // * in case of modification
        if (location?.state?.aoId) {
            response1 = await postData({ url: `/ao/updateAOById/${location?.state?.aoId}`, payload: payloadStep2, });
        }
        // * in case of creation
        else {
            // debugger;
            response1 = await postData({ url: '/ao/createAO_step2', payload: { aoId: _id, ...payloadStep2 } });
            console.log(response1?.createdAO);
            if (isHttpStatusSuccess(response1.responseStatus)) {
                setSelectedAO(response1?.data?.createdAO);
                // let stateToPass = {
                //     payloadStep2: { ...payloadStep2, aoId: _id },
                //     payloadStep3: { ...selectedAO?.payloadStep3, _id: _id },
                // };
                // console.log(stateToPass);
                // setSelectedAO(stateToPass);
                if (action == 'validate') {
                    // ! pb: router state props could not handle this amount of passed Data :) , so I will use ContextAPI with Custom hooks
                    navigate(`/${role}/createAO/last`);
                }
            }
        }
    };

    return (
        <form className='HomeAO2'>
            <CreateAOButtonsHeader
                aoId={location?.state?.aoId}
                intitulePoste={intitulePoste}
                role={role}
            />
            <div className='DetailsPublication'>
                <h6 className='nomPrenomProfile'>{i18n.t('Détails de la publication')}</h6>
                <div className='B1Pub'>
                    <div className='B1Pub1'>
                        <div className='Frame10129'>
                            <p className='IntitulePoste'>{i18n.t('Intitulé du poste')}</p>
                            <TextFieldComponent
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                style={{ width: '100%' }}
                                type="text"
                                name="intitulePoste"
                                // placeholder="Intitulé du poste"
                                autoComplete="off"
                                value={intitulePoste}
                                onChange={(e) => setIntitulePoste(e.target.value)}
                            />
                        </div>
                        <div className='Frame10129'>
                            <p className='IntitulePoste'>{i18n.t('Référence interne')}</p>
                            <TextFieldComponent
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                style={{ width: '100%' }}
                                type="text"
                                name="referenceInterne"
                                // placeholder="referenceInterne"
                                autoComplete="off"
                                value={referenceInterne}
                                onChange={(e) => setReferenceInterne(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='B1Pub1'>
                        <div className='Frame10129'>
                            <p className='IntitulePoste'>{i18n.t('Date de début (publication)')}
                            </p>
                            <DatePickerComponent
                                label=""
                                date={dateDebutAO}
                                name='dateDebutAO'
                                setDate={(newValue) => {
                                    setDateDebutAO(newValue);
                                }}
                                width={'100%'}
                                // * passing error and textHelper didn't work with normal way
                                // error={isValidRangeDateAO && !!messageRangeDateAO}
                                // helperText={isValidRangeDateAO ? messageRangeDateAO : null}
                                disablePast
                            />
                        </div>
                        <div className='Frame10129'>
                            <p className='IntitulePoste'>{i18n.t('Date de fin (publication)')}</p>
                            <DatePickerComponent
                                label=""
                                date={dateFinAO}
                                name='dateFinAO'
                                setDate={(newValue) => {
                                    setDateFinAO(newValue);
                                }}
                                width={'100%'}
                                // * I may need :{  },
                                disablePast
                                // ! later on: make the message at the second input ( date fin)
                                error={isValidRangeDateAO && !!messageRangeDateAO}
                                helperText={isValidRangeDateAO ? messageRangeDateAO : null}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className='DonneesGeneral'>
                <h6 className='nomPrenomProfile'>{i18n.t('Données générales')}</h6>
                <div className='B1Pub'>
                    <div className='B1Pub1'>
                        <div className='Frame10129'>
                            <p className='IntitulePoste'>{i18n.t('Nombre de recrutés')}</p>
                            <IconTextField
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px', },
                                }}
                                style={{ width: '100%' }}
                                type="number"
                                name="nbRecrutes"
                                // placeholder="Entrer le nb Recrutes"
                                autoComplete="off"
                                onKeyDown={handleKeyDown}
                                value={nbRecrutes}
                                onChange={(e) => setNbRecrutes(e.target.value)}
                                iconStart={<PersonOutlineOutlinedIcon />}
                                InputProps={{
                                    inputProps: { min: 1 },
                                    //startAdornment:
                                    //(<div className='iconStyleStartAdornment'> <InputAdornment position="start">
                                    //    <PersonOutlineOutlinedIcon />
                                    //</InputAdornment></div>),

                                }}
                            />
                        </div>
                        <div className='Frame10129'>
                            <p className='IntitulePoste'>{i18n.t('Localisation')}</p>
                            <SearchCity
                                name='localisation'
                                setCity={setLocalisation}
                                city={localisation}
                                width={'100%'}
                            />
                        </div>
                    </div>
                    <div className='B1Pub1'>
                        <div className='Frame10129'>
                            <p className='IntitulePoste'>{i18n.t('Minimum d\'années d\'expérience')}</p>
                            <IconTextField
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px', },
                                }}
                                style={{ width: '100%' }}
                                type="number"
                                onKeyDown={handleKeyDown}
                                name="minAnnExp"
                                value={minimumAnneeExp}
                                iconEnd={i18n.t('ans')}
                                InputProps={{
                                    //endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">ans</InputAdornment></div>),
                                    inputProps: { min: 1,}
                                }}
                                onChange={(e) => {
                                    setMinimumAnneeExp(e.target.value);
                                }}
                                autoComplete="off"
                            />
                        </div>
                        <div className='Frame10129'>
                            <p className='IntitulePoste'> {i18n.t('Catégories & Sous catégorie')}</p>
                            <CategoriesSubCategoriesDropDown
                                setCategorie={setCategorie}
                                setSousCategorie={setSousCategorie}
                                sousCategorie={sousCategorie}
                                width={'100%'}
                                name='sousCategorie'
                            />
                        </div>
                    </div>
                    <RegimeModeTravail
                        setModeTravail={setModeTravail}
                        setRegimeTravail={setRegimeTravail}
                        modeTravail={modeTravail}
                        regimeTravail={regimeTravail}
                    />
                </div>
            </div>

            <div className='BudgetDuration'>
                <h6 className='nomPrenomProfile'>{i18n.t('Duration et budget')}</h6>
                <div className='B1Pub'>
                    <div className='B1Pub1'>
                        <div className='Frame10129'>
                            <p className='IntitulePoste'>{i18n.t('Date de début (mission)')}
                            </p>
                            <DatePickerComponent
                                label=""
                                date={dateDebutMission}
                                name='dateDebutMission'
                                setDate={(newValue) => {
                                    setDateDebutMission(newValue);
                                }}
                                width={'100%'}
                                disablePast
                            // marginTop: '-10px'
                            />
                        </div>
                        <div className='Frame10129'>
                            <p className='IntitulePoste'>{i18n.t('Date estimée de fin (mission)')}</p>
                            <DatePickerComponent
                                label=""
                                date={dateFinMission}
                                name='dateFinMission'
                                setDate={(newValue) => {
                                    setDateFinMission(newValue);
                                }}
                                width={'100%'}
                                disablePast
                                // marginTop: '-10px'
                                error={isValidRangeDateMission && !!messageRangeDateMission}
                                helperText={isValidRangeDateMission ? messageRangeDateMission : null}
                            />
                        </div>
                    </div>
                    <div className='B1Pub1'>
                        <div className='Frame10129'>
                            <p className='IntitulePoste'>{i18n.t('Durée de mission')}</p>
                            <IconTextField
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px', },
                                }}
                                style={{ width: '100%' }}
                                type="number"
                                name="dureeMission"
                                value={dureeMission}
                                iconEnd={'jr'}
                                InputProps={{
                                    inputProps: { min: 1,},
                                    //endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">jours</InputAdornment></div>) }}
                                }}
                                // readOnly
                                //autoComplete="off"
                                //min="0"
                                onChange={(e) => setDureeMission(e.target.value)}
                            />
                        </div>
                        <div className='Frame10129'>
                            <p className='IntitulePoste'>{i18n.t('Durée du BDC')}</p>
                            <SelectComponent
                                val={dureeBDC}
                                name="dureeBDC"
                                setVal={(e) => setDureeBDC(e.target.value)}
                                listVal={dureeBdcEnum}
                            />
                        </div>
                    </div>
                    <div className='B1Pub1'>
                        <div className='Frame10129'>
                            <p className='IntitulePoste'>{i18n.t('Budget maximum/jour')}</p>
                            <IconTextField
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                style={{ width: '100%' }}
                                type="number"
                                min="0"
                                name="tj"
                                iconEnd={'€'}
                                //InputProps={{ endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>) }}
                                placeholder="Entrer le Taux journalier "
                                autoComplete="off"
                                value={tjMax}
                                onChange={(e) => setTjMax(e.target.value)}
                            />
                        </div>
                        <div className='Frame10129'>
                            <p className='IntitulePoste'>{i18n.t('Budget de la mission')}</p>
                            <IconTextField
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px', },
                                }}
                                style={{ width: '100%' }}
                                type="number"
                                min="0"
                                name="tj"
                                iconEnd={'€'}
                                //InputProps={{ endAdornment:(<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end"> €</InputAdornment></div>) }}
                                placeholder="Entrer le Taux journalier "
                                autoComplete="off"
                                value={Number(tjMax) * dureeMission}
                                disabled
                            />
                        </div>
                    </div>
                    <div className='B1Pub1'>
                        <div className='Frame10129'>
                            <FormGroup>
                                <ThemeProvider theme={FieldComponentFont}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                defaultChecked
                                                checked={visibilityTjMax}
                                                onChange={() => {
                                                    setVisibilityTjMax(!visibilityTjMax);
                                                }}
                                                inputProps={{ 'aria-label': 'controlled' }}
                                            />}
                                        label={i18n.t('Visibilité Budget dans l\'AO')}
                                    />
                                </ThemeProvider>
                            </FormGroup>
                        </div>
                    </div>
                </div>
            </div>

            <div className='Descriptionduposte'>
                <h6 className='IntitulePoste'>{i18n.t('Description du poste')}</h6>
                <div
                    className='B1Pub'
                    style={{ maxHeight: '600px', overflow: 'auto' }}
                >
                    <QuillAdvancedTextArea
                        value={description ?? ''}
                        name='description'
                        // ? si le backOffice la modifie, une notification envoyee a le sera suffisante
                        placeholder="Description du poste..."
                        setValue={setDescription}
                        style={{
                            width: '100%',
                        }}
                    />
                </div>
            </div>
            <div className='TableauCR'>
                <div
                    className='B1Pub1'
                    style={{ justifyContent: 'space-between' }}
                >
                    <h6
                        className='nomPrenomProfile'
                        style={{ order: device == 'desktop' ? '0' : '1' }}
                    >{i18n.t('Equipe chargée du recrutement et/ou suivi du projet')}</h6>
                    <div
                        className='MembreAjout'
                        style={{ order: device == 'desktop' ? '1' : '0', justifyContent: 'end', width: '35%' }}
                    >
                        <Button
                            variant="primary"
                            style={{
                                backgroundColor: 'white', width: '120px', height: '40px',
                                color: '#214DCE', fontWeight: 'bold', fontFamily: 'Lato'
                            }}
                            className="col-4"
                            onClick={(e) => {
                                e.preventDefault();
                                let index = membres.length;
                                let newArr = [...membres]; // copying the old datas array
                                newArr.push(initializeMembre(index,location?.pathname?.includes('esn')? 'esn':'client'));
                                setMembres(newArr);
                                // console.log(e, membres, newMembres);
                            }}
                        >
                            {i18n.t('+ Membre')}
                        </Button>
                    </div>
                </div>
                <Table
                    striped
                    bordered
                    hover
                    className='TabBox'
                    style={{ width: '100%' }}
                >
                    <thead>
                        <th className='firstabhd'>{i18n.t('Nom')}</th>
                        {/* <th className='secondtabhd'>Rôle</th> */}
                        <th className='secondtabhd'>{i18n.t('Gestion des candidatures')}</th>
                        <th className='lastabhd'>{i18n.t('Suivi projet')}</th>
                    </thead>
                    {membres?.length ? (
                        <tbody>
                            {membres.map((membre, i) => (
                                <tr key={i}>
                                    <td style={{ width: '25%', textAlign: 'center' }}>
                                        <SearchUser
                                            // size={'medium'}
                                            // setUser={setResponsableOperationnel}
                                            // userId={responsableOperationnel?._id??responsableOperationnel}
                                            userId={membre?.collaboratorId ?? membre?.collaboratorEsnId}
                                            placeholder={'Choisir...'}
                                            userType={role=='esn'? 'Esn' :'Client'}
                                            setUser={(newValue) => {
                                                if (i !== 0) {
                                                    let newArr = [...membres]; // copying the old datas array
                                                    if(location?.pathname?.includes('esn'))
                                                        newArr[i].collaboratorEsnId = newValue?._id;
                                                    else
                                                        newArr[i].collaboratorId = newValue?._id;
                                                    setMembres(newArr);
                                                }
                                            }}
                                            companyId={selectedAO?.companyDataId?._id ??selectedAO?.companyDataId ??selectedAO?.esnId }
                                            // user={AUser}
                                            variant={'standard'}
                                            width={'100%'}
                                            InputProps={{
                                                startAdornment:
                                                (<div className='iconStyleStartAdornment'>
                                                    <InputAdornment position="start">
                                                        <PersonOutlineOutlinedIcon />
                                                    </InputAdornment>
                                                </div>)
                                            }}
                                            disabled={i == 0}
                                        />
                                    </td>
                                    {/*
                                    //* role removed ( try to not delete it from comment)
                                    <td style={{ width: '30%', textAlign: 'center' }}>
                                        <ThemeProvider theme={FieldComponentFont}>
                                            <Autocomplete
                                                disablePortal
                                                sx={{ width: '100%' }}
                                                value={membre?.role ? { label: membre?.role } : { label: 'choisir ...' }}
                                                onChange={(event, newValue) => {
                                                    let newArr = [...membres];
                                                    newArr[i].role = newValue?.label;
                                                    setMembres(newArr);
                                                }}
                                                id="combo-box-demo"
                                                options={[
                                                    //Collaborators Roles:  Admin -littleAdmin - Rh- Manager-ResponsableAchat- Comptable
                                                    { label: 'Admin' }, { label: 'Responsable achat' },{ label: 'RH' },{label:'Responsable opérationnel'},
                                                    {label:'Comptable'}]}
                                                //options=[]
                                                renderInput={(params) =>
                                                    <TextFieldComponent
                                                        {...params}
                                                        variant='standard'
                                                        placeholder='Choisir un rôle'
                                                    />
                                                }
                                            />
                                        </ThemeProvider>
                                    </td> */}
                                    <td style={{ textAlign: 'center' }}>
                                        <Checkbox
                                            defaultChecked
                                            checked={membre.receptionCandidatures}
                                            onChange={() => {
                                                let newArr = [...membres];
                                                newArr[i].receptionCandidatures = !membre.receptionCandidatures;
                                                setMembres(newArr);
                                            }}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                    </td>
                                    <td
                                        style={{
                                            width: '15%',
                                            textAlign: 'center',
                                        }}
                                    >
                                        <Checkbox
                                            defaultChecked
                                            checked={membre.suiviMission}
                                            onChange={() => {
                                                let newArr = [...membres];
                                                newArr[i].suiviMission = !membre.suiviMission;
                                                setMembres(newArr);
                                            }}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                        {i !== 0 ?
                                            <DeleteForeverOutlinedIcon
                                                onClick={(e) => {
                                                    let newArr = [
                                                        ...membres.slice(0, i),
                                                        ...membres.slice(i + 1, membres.length),
                                                    ];
                                                    // let newArr = [...experienceState]; // copying the old datas array
                                                    // replace e.target.value with whatever you want to change it to
                                                    setMembres(newArr);
                                                    console.log(e, membres);
                                                }}
                                            /> :
                                            <p style={{ display: 'inline-block', width: '24px' }}>  </p>  //is useless just to line up all the checkboxes
                                        }
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <p className='IntitulePoste'>{i18n.t('aucun membre a afficher')}</p>
                    )}
                </Table>
            </div>
            {/* //! location.satet incase of MODIF */}
            {location?.state?.aoId ?
                <div className='Frame010101'>
                    <Button
                        style={{ ...buttonStyles(false) }}
                        variant="outlined"
                        onClick={(e) => {
                            e.preventDefault();
                            navigate(`/${role}/aos`);
                        }}
                    >
                        {i18n.t('Retour aux AO')}
                    </Button>
                    <Button
                        style={{ ...buttonStylesGreen((isValidRangeDateMission && !!messageRangeDateMission) || (isValidRangeDateAO && !!messageRangeDateAO)) }}
                        //{{ backgroundColor: '#214DCE', width: '150px', height: '56px', fontFamily: 'Lato', fontStyle: 'normal', fontWeight: 600, fontSize: '20px', lineHeight: '32px', alignItems: 'center', textAlign: 'center', letterSpacing: '-0.15px', color: 'white', borderRadius: '8px' }}
                        type="submit"
                        //className='ButtonSubmit'
                        disabled={(isValidRangeDateMission && !!messageRangeDateMission) || (isValidRangeDateAO && !!messageRangeDateAO)}
                        onClick={(e) => {
                            e.preventDefault();
                            if (isValid) {
                                createAO_step2({ action: 'update' }); //* even it doisn t matter, but without it we will have: front end error: annot destructure property 'action' o
                                setShowErrors(false);
                                setErrors({});
                            }
                            else setShowErrors(true);
                        }}
                    >
                        {i18n.t('Sauvegarder')}
                    </Button>
                </div>
                :
                <div
                    className='B1Pub2'
                    style={{ justifyContent: device == 'desktop' ? 'end' : 'start' }}
                >
                    {/*
                     //! dans ce cas, la premiere partie cree un nouveau AO. ce qui peut recreer un AO due to the proccess of creation is now step by step ... we need a trigger ..
                    <Button
                        variant='outlined'
                        style={{...buttonStyles(),...{ color: '#214DCE'}}}
                        onClick={() => navigate(-1)}
                    >
                            Retour
                    </Button> */}
                    <div className='SSBtn'>
                        {role == 'client' &&
                        <Button
                            disabled={(isValidRangeDateMission && !!messageRangeDateMission) || (isValidRangeDateAO && !!messageRangeDateAO)}
                            onClick={(e) => {
                                e.preventDefault();
                                createAO_step2({ action: 'save' });
                                setShowErrors(false);
                                setErrors({});
                            }}
                            style={{ ...buttonStylesGreen(((isValidRangeDateMission && !!messageRangeDateMission) || (isValidRangeDateAO && !!messageRangeDateAO))), ...{ width: device == 'desktop' ? '164px' : '100%', order: device == 'desktop' ? '1' : '0' } }}
                        >
                            {i18n.t('Sauvegarder')}
                        </Button>}
                        <Button
                            type='submit'
                            style={{ ...buttonStylesGreen(((isValidRangeDateMission && !!messageRangeDateMission) || (isValidRangeDateAO && !!messageRangeDateAO))), ...{ width: device == 'desktop' ? '120px' : '100%', order: device == 'desktop' ? '0' : '1' } }}
                            //! this is a choice, but I prefer to n disabled={!isValid}
                            disabled={(isValidRangeDateMission && !!messageRangeDateMission) || (isValidRangeDateAO && !!messageRangeDateAO)}
                            onClick={(e) => {
                                e.preventDefault();
                                if(!isValid) {
                                    setErrors({...errors, ...{nbJrsPartielPerWeek: ''}});
                                    setShowErrors(true);
                                }
                                else if (regimeTravail.type == 'temps-partiel' && isNaN(parseFloat(regimeTravail.nbJrsPartielPerWeek))){
                                    setErrors({...errors, ...{nbJrsPartielPerWeek: champRequisString}});
                                    setShowErrors(true);
                                }
                                else {
                                    createAO_step2({ action: 'validate' });
                                    setShowErrors(false);
                                    setErrors({});
                                }
                            }}
                        >
                            {i18n.t('Suivant')}
                        </Button>
                    </div>
                </div>
            }
        </form>
    );
}
export default CreateAOSecond;
